import InputKeyword from "./InputKeyword";

const AddKeywords = () => {
  return (
    <div className="section">
      <div className="section-title">Keywords</div>
      <InputKeyword />
    </div>
  );
};

export default AddKeywords;
